export class EmailNotification {
  id: string;
  hiring_firm: string;
  address: string;
  is_hiring_type: boolean;
  is_candidate_type: boolean;

  constructor(public email: string = '') { }
}
